export default __webpack_public_path__ + "media/images/front/municipality_collaboration/kagoshima_island_company/ogp-182922ce06ee4f03e0f8a47d42d8c77c.png";